import React from 'react';
import { Alert } from 'antd';
import Translate from 'react-translate-component';

export default function EmptyDocument () {
    return (
        <Alert
            message={<Translate content="error.empty_document" />}
            type="error"
            className="document-empty"
        />
    );
}
